import React from 'react';
import classnames from 'classnames';

import {Wrapper} from './Link.styles';

function Link({label, onClick, style, customClasses, rightIconClass}) {
  return (
    <Wrapper>
      <span onClick={onClick} className={classnames('link', style?.customClasses, customClasses)}>
        {label}
        {rightIconClass && <span className={classnames(rightIconClass, 'appendLeft10')} />}
      </span>
    </Wrapper>
  );
}

export default Link;
